import { Avatar, Box, Divider, Grid, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { selectSubjectInsUpd } from "../../../../redux/curriculum/subjectInsUpdSlice";
import { assertImagesUrl } from "../../../../redux/common";

export function SubjectInsUpdReview() {
    const subjectInsUpd = useSelector(selectSubjectInsUpd);

    return <>
        <Typography variant="h6" gutterBottom>
            Revisão
        </Typography>
        <Grid container spacing={3}>
            <Grid size={2}>
                <Typography component="div" variant="body1" color="darkgray" align="right">Nome</Typography>
            </Grid>
            <Grid size={10}>
                <Typography component="div" variant="body1" color="darkblue">{subjectInsUpd.subject.name}</Typography>
            </Grid>
            <Grid size={2}>
                <Typography component="div" variant="body1" color="darkgray" align="right">Avatar</Typography>
            </Grid>
            <Grid size={10}>
                <Box sx={{ display: "flex", alignItems: "center", m: 1 }}>
                    <Avatar
                        src={assertImagesUrl(subjectInsUpd.subject.url)}
                        alt={subjectInsUpd.subject.name}
                        sx={{ width: 60, height: 60, border: "1px solid #ccc" }}
                    />
                </Box>
            </Grid>
        </Grid>
        <Divider flexItem />
    </>;
}
